import { useNavigate } from 'react-router-dom';

const ArticleCard = ({
	title,
	description,
	image,
	courses,
	path,
	instructor,
}) => {
	const navigate = useNavigate();

	const goToAbout = () => {
		navigate(path);
	};
	return (
		<div className='bg-blue-50  rounded-xl shadow-md p-4 border border-blue-200 hover:shadow-xl shadow-blue-200 transition-transform duration-300'>
			<div className='rounded-xl overflow-hidden'>
				<img
					src={image}
					alt={title}
					className='rounded-xl object-cover h-64 w-full '
				/>
			</div>
			<h3 className='text-blue-800 font-bold text-lg text-center mt-2'>
				{title}
			</h3>
			<p className='text-gray-800 text-sm mt-2 line-clamp-2'>{description}</p>
			<div className='flex items-center justify-between mt-4 text-blue-700 font-semibold	'>
				{courses}
				{instructor}
			</div>
			<button
				onClick={goToAbout}
				className='mt-3 px-4 py-2 rounded-lg border border-blue-500
				text-blue-800 hover:bg-blue-500 hover:text-white transition-colors
				w-full'>
				المزيد
			</button>
		</div>
	);
};

export default ArticleCard;
